import { render } from "./OpticFieldComponent.vue?vue&type=template&id=3c010f90"
import script from "./OpticFieldComponent.vue?vue&type=script&lang=js"
export * from "./OpticFieldComponent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Documents\\Github\\OpticTool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__